import { Link } from "react-router-dom";
import "./ScrollGallery.css";

import img1 from "../../assets/proyectos/cubo.png";
import img2 from "../../assets/proyectos/timbox.png";
import img3 from "../../assets/proyectos/tax.png";
import img4 from "../../assets/proyectos/caisat.png";
import img5 from "../../assets/proyectos/tum.png";

const cards = [
    { id: 1, image: img1, link: "https://www.cuboconecta.com/" },
    { id: 2, image: img2, link: "https://www.timbox.com.mx/" },
    { id: 3, image: img3, link: "" },
    { id: 4, image: img4, link: "" },
    { id: 5, image: img5, link: "" },

];

const infiniteCards = [...cards, ...cards, ...cards];

export default function ScrollGallery() {

    return (
        <section className="gallery-section">

            <div className="gallery-track">
                {infiniteCards.map((card, index) => (
                    <Link
                        key={index}
                        to={card.link}
                        className="gallery-card"
                        target="_blank"
                    >
                        <img src={card.image} alt=""/>

                        <div className="overlay">
                            <span>Ver proyecto</span>
                        </div>
                    </Link>
                ))}
            </div>

        </section>
    );
}
